import InstructionContent from "./instruction-content";

export default {
    components: {
        instructionContent: InstructionContent,
    }
}
